/** @file boneMaterial: the unlit, always-on-top material of the wire bones (instance colour, no depth test). */
import '@babylonjs/core/Shaders/ShadersInclude/instancesDeclaration.js';
import '@babylonjs/core/Shaders/ShadersInclude/instancesVertex.js';
import { Constants } from '@babylonjs/core/Engines/constants.js';
import { ShaderMaterial } from '@babylonjs/core/Materials/shaderMaterial.js';
import type { Scene } from '@babylonjs/core/scene.js';

/** Position through the thin-instance world matrix; the instance colour goes on. */
const VERTEX = `precision highp float;
attribute vec3 position;
#include<instancesDeclaration>
uniform mat4 viewProjection;
varying vec4 vColor;
void main() {
#include<instancesVertex>
#ifdef INSTANCESCOLOR
  vColor = instanceColor;
#else
  vColor = vec4(1.0);
#endif
  gl_Position = viewProjection * finalWorld * vec4(position, 1.0);
}`;

/** The instance colour as is. */
const FRAGMENT = 'precision highp float; varying vec4 vColor; void main() { gl_FragColor = vColor; }';

/** One per scene (cached by name): both faces, alpha blended, no depth write and no depth test (always on top). */
export function boneMaterial(scene: Scene): ShaderMaterial {
  const found = scene.getMaterialByName('viewport-bone-wire');
  if (found instanceof ShaderMaterial) return found;
  const m = new ShaderMaterial('viewport-bone-wire', scene, { vertexSource: VERTEX, fragmentSource: FRAGMENT }, {
    attributes: ['position'], uniforms: ['world', 'viewProjection'], needAlphaBlending: true,
  });
  Object.assign(m, { backFaceCulling: false, disableDepthWrite: true, depthFunction: Constants.ALWAYS, alphaMode: Constants.ALPHA_COMBINE });
  return m;
}
